export enum UmRole {
  Admin = 3,
  Agent = 4,
  ProjectAdmin = 5,
  ProjectHead = 6,
  Stakeholder = 7,
  DepartmentHead = 8,
  Dashboard = 11,
  ActionPlan = 12,
  VxStrategy = 16,
  SectionManager = 17,
  ProjectManager = 18,
  MilestoneManager = 22,
  TaskManager = 19,
}
